module.exports = __webpack_public_path__ + "img/person-plug-mini.f9ff2799.png";